import CommonBulkUpload from "@components/BulkUpload";
import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import {
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from "reactstrap";
import ImportPopup from "./importPopup";
import ReactTooltip from "react-tooltip";
import UploadSubheaderSvgComponent from "../../assets/svg-components/sub-header/upload";



function BulkUploadDropdown(props: any) {
	const { dropdownOptions, url, type, handleDownload, onDownload } = props;
	const [selectedOption, setSelectedOption] = useState("");
	const [isBulkUploadPopupVisible, setBulkuploadPopupVisibility] =
		useState(false);
	return (
		<div className="icon-dropdown-holder ms-0 ">
		<ReactTooltip id="subHeaderUpload" effect="solid" place="bottom">
			Upload
		</ReactTooltip>
			<UncontrolledDropdown>
				<DropdownToggle className="icons-btn p-0" data-tip data-for="subHeaderUpload">
					{/* <div className="add-filter-wrapper__filter-container">
						<div className="cursor-pointer">
							<img
								src="/images/file-upload.svg"
								className="img-fluid add-filter-wrapper__upload-image"
							/>
							<p className="add-filter-wrapper__filter-title">BULK UPLOAD</p>
						</div>
					</div> */}
					{/* <button
						className="icons-btn p-0"
						data-tip
						data-for="subHeaderUpload"
						> */}
						<UploadSubheaderSvgComponent  />
					{/* </button> */}
				</DropdownToggle>
				<DropdownMenu>
					{getValue(dropdownOptions, `length`, 0) > 0 &&
						dropdownOptions.map((item: object) => {
							return (
								<DropdownItem
									onClick={() => {
										setSelectedOption(getValue(item, `value`, ""));
										setBulkuploadPopupVisibility(true);
									}}
								>
									{getValue(item, `label`, "")}
								</DropdownItem>
							);
						})}
				</DropdownMenu>
			</UncontrolledDropdown>
			{isBulkUploadPopupVisible && (
				<ImportPopup
					url={url}
					type={selectedOption}
					setBulkuploadPopupVisibility={setBulkuploadPopupVisibility}
					isBulkUploadPopupVisible={isBulkUploadPopupVisible}
					setSelectedOption={setSelectedOption}
					handleDownload={handleDownload || onDownload}
				/>
			)}
		</div>
	);
}

export default BulkUploadDropdown;
